import React from 'react';

const Cross = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="currentColor"
    {...props}
  >
    <path d="M25.2071 8.20711C25.5976 7.81658 25.5976 7.18342 25.2071 6.79289C24.8166 6.40237 24.1834 6.40237 23.7929 6.79289L16 14.5858L8.20711 6.79289C7.81658 6.40237 7.18342 6.40237 6.79289 6.79289C6.40237 7.18342 6.40237 7.81658 6.79289 8.20711L14.5858 16L6.79289 23.7929C6.40237 24.1834 6.40237 24.8166 6.79289 25.2071C7.18342 25.5976 7.81658 25.5976 8.20711 25.2071L16 17.4142L23.7929 25.2071C24.1834 25.5976 24.8166 25.5976 25.2071 25.2071C25.5976 24.8166 25.5976 24.1834 25.2071 23.7929L17.4142 16L25.2071 8.20711Z" />
  </svg>
);

export default Cross;
